import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Container,
  useMediaQuery,
} from "@mui/material";
import Logo from "../../assets/images/Logo.svg";
import LogoName from "../../assets/images/LogoName.png";
import Image from "../../assets/images/Image.svg";
import { useNavigate } from "react-router-dom";
import "../../styles/inputBox.css";
import { postRequest } from "../../api/apiServices";
import apiList from "../../api/apiList";
import Toast from "../../utils/Toast";

const ForgotPasswordEmail: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState<string>("");
  const isMobile = useMediaQuery("(max-width:578px)");
  const isBigScreen = useMediaQuery("(min-width:900px)");

  useEffect(() => {
    document.title = "Forgot Password - Sprooze";
  }, []);
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setEmailError("");

    if (!email) {
      setEmailError("Email is required");
      return;
    }

    setLoading(true);

    const reasponse: any = await postRequest(apiList.forgotpassword, {
      email: email,
    });
    Toast(reasponse?.data?.statusMessage || "Email sent successfully");
    navigate("/emailverify", {
      state: { email: email, forgotPasswordMode: true },
    });

    setLoading(false);
  };

  return (
    <div style={{ backgroundColor: "#F4F4F4" }}>
      <Container
        maxWidth="md"
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#F4F4F4",
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="center"
          bgcolor="#FFFFFF"
          // alignItems="center"
          borderRadius="22px"
          // height={700}
          margin={0}
          // width="max-content"
        >
          {/* Form Column */}
          <Grid
            item
            xs={12}
            md={6}
            height={isMobile ? "fit-content" : "auto"}
            // bgcolor="green"
            justifyContent="center"
            style={{ padding: 30 }}
          >
            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={2}
                height="100%"
                justifyContent="space-between"
                direction="column"
              >
                <Grid
                  container
                  spacing={2}
                  width="100%"
                  direction="column"
                  margin={0}
                  padding={0}
                >
                  <Grid item>
                    {!isBigScreen && (
                      <Grid
                        item
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <img
                          src={LogoName}
                          style={{
                            width: "70%",
                          }}
                        />
                      </Grid>
                    )}
                    <Typography
                      color="#273848"
                      fontWeight={700}
                      fontSize="29.94px"
                    >
                      Forgot Password
                    </Typography>
                    <Typography
                      color="#273848"
                      fontWeight={500}
                      fontSize="14px"
                    >
                      Enter your email address to receive a verification OTP.
                    </Typography>
                  </Grid>
                  <Grid item></Grid>
                  <Grid item className="margin-top">
                    <Typography className="input-label-custom">
                      Enter Email
                    </Typography>
                    <TextField
                      placeholder="Email Address"
                      fullWidth
                      className="input-box-custom"
                      sx={{
                        mt: 1,
                        "& .MuiOutlinedInput-input": {
                          padding: "10px 11px", // Add padding here
                        },
                      }}
                      style={{ font: "caption" }}
                      value={email}
                      error={!!emailError}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setEmailError(""); // Clear error on input change
                      }}
                      InputProps={{
                        style: {
                          font: "caption",
                          fontWeight: 500,
                        },
                      }}
                    />
                    {emailError && (
                      <Typography color="error" fontSize={12}>
                        {emailError}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item>
                    <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      style={{
                        backgroundColor: "#84E1CC",
                        boxShadow: "none",
                        borderRadius: "5px",
                        padding: "17px 17px",
                        lineHeight: "0px",
                        textTransform: "none",
                        letterSpacing: "0px",
                        marginTop: "25px", // Add some margin to separate the button from the link
                      }}
                    >
                      Send OTP
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Grid>
          {/* Image Column */}
          {isBigScreen && (
            <Grid
              item
              xs={12}
              md={6}
              style={{
                padding: 0,
                position: "relative",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  background: `url(${Logo})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "0 22px 22px 0",
                  // opacity: 0.5,
                }}
              />
              <img
                src={Image}
                alt="ForgotPassword Image"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "0 22px 22px 0",
                  objectFit: "cover",
                }}
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default ForgotPasswordEmail;
